import { addToChainBefore } from "@insite/client-framework/HandlerCreator";
import { chain, ClearSearch } from "@insite/client-framework/Store/Pages/InvoiceHistory/Handlers/ClearSearch";
import CustomClearInvoiceHistoryFilters from "@tKgpco/Store/Data/InvoiceHistoy/Handler/CustomClearInvoiceHistoryFilters";

addToChainBefore(chain, ClearSearch, props => {
    const getInvoiceHistoryParams = props.getState().pages.invoiceHistory.getInvoicesParameter;
    props.dispatch(CustomClearInvoiceHistoryFilters({ clearInvoiceHistoryFilters: true, getInvoiceHistoryParams }));
});
